import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveFloat16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveFloat16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M15.166 9.138a.6.6 0 0 1-.571.627c-.72.033-1.211-.338-1.53-.569-.347-.25-.522-.36-.777-.35-.232.008-.387.112-.697.348-.288.219-.73.567-1.4.57-.677.005-1.128-.347-1.42-.569-.317-.238-.474-.343-.71-.35-.258-.006-.434.101-.769.34-.312.222-.785.579-1.481.58-.7 0-1.174-.357-1.488-.58-.337-.24-.514-.346-.773-.34-.234.008-.39.112-.705.35-.292.221-.74.573-1.416.57a.6.6 0 1 1 .006-1.2c.225.001.377-.094.685-.327.285-.215.728-.572 1.396-.591.705-.02 1.183.333 1.503.56.342.244.524.359.79.359.265 0 .446-.116.787-.359.317-.226.794-.578 1.496-.56.67.016 1.116.374 1.402.59.31.234.463.33.69.329s.376-.097.68-.328c.282-.214.72-.568 1.381-.591.718-.026 1.207.347 1.524.576.345.25.518.354.77.343a.6.6 0 0 1 .627.572M12.89 6.5a3 3 0 0 0-.472-.054h-.217a3 3 0 0 0-.576.077 3.946 3.946 0 0 0-7.32.008 3 3 0 0 0-.615-.085h-.21q-.228.007-.434.043a5.15 5.15 0 0 1 4.92-3.635l.265.007a5.15 5.15 0 0 1 4.659 3.64m-.327 3.81a5.14 5.14 0 0 1-4.596 2.835l-.265-.007A5.15 5.15 0 0 1 3.364 10.3q.126-.09.203-.15l.02-.014.039.026c.241.172.83.629 1.694.763.7.633 1.629 1.02 2.647 1.02a3.93 3.93 0 0 0 2.635-1.011c.886-.124 1.476-.606 1.713-.786l.007-.006.04.026c.05.037.12.085.201.142"
            />
        </svg>
    );
}
export default memo(IconMoveFloat16);
